import React from "react";
import { Alert } from 'antd';

const AlertNotice = ({ message, type}) => {
  return (
    <Alert style={{textAlign: "center"}} message={message} type={type} />
  )
}

export default AlertNotice;
